import * as React from 'react';
import { notification } from 'antd';
import CustomIcon from '../CustomIcon';
import s from './Notification.module.less';

type Placement = 'bottomLeft' | 'topLeft' | 'topRight' | 'bottomRight';
type Args = {
  title?: React.ReactNode;
  text?: React.ReactNode;
  placement?: Placement;
  top?: number;
  className?: string | null;
  duration?: number;
};

const DefaultDuration = 3.5;
const DefaultPlacement = 'bottomLeft';
const closeIcon = <CustomIcon type="close" />;

export default {
  success: ({ title, text, placement = DefaultPlacement, duration = DefaultDuration }: Args) => {
    notification.open({
      message: title,
      description: text,
      className: s.successNotification,
      placement,
      closeIcon,
      duration,
    });
  },
  info: ({ title, text, placement = DefaultPlacement, duration = DefaultDuration }: Args) => {
    notification.open({
      message: title,
      description: text,
      className: s.infoNotification,
      placement,
      duration,
      closeIcon,
    });
  },
  error: ({ title, text, placement = DefaultPlacement }: Args) => {
    notification.open({
      message: title,
      description: text,
      className: s.errorNotification,
      placement,
      duration: null,
      icon: <CustomIcon type="exclamation-circle" className={s.exclamationIcon} />,
      closeIcon,
    });
  },
  saveSuccess: ({
    title,
    text,
    placement = DefaultPlacement,
    top,
    duration = DefaultDuration,
  }: Args) => {
    notification.open({
      message: title,
      className: s.saveNotification,
      placement,
      top,
      duration,
      description: text,
      icon: <CustomIcon type="heart" className={s.heartIcon} />,
      closeIcon,
    });
  },
};
